module.exports = __webpack_public_path__ + "static/media/assinatura-serpro-govfederal-vert-negativo-2025-01.5f272451.png";